import React, { useEffect, useState } from "react";
import Navbar from "../Components/Navbar";
import img from "../Assets/Mobile login-pana 2.png";
import Footer from "../Components/Footer";
import { Link, useNavigate } from "react-router-dom";
import { signupUser } from "../Common/auth.js";
import Loader from "../Loader/Loader.jsx";
import { toast } from "react-toastify";
import Aos from "aos";

const SignUp = () => {
  useEffect(() => {
        Aos.init({
          duration: 1000, // animation duration in ms
          once: true,     // animate only once
        });
      }, []);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    name: "",
    phone: "",
    password: ""
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // const handleChange = (e) => {
  //   setFormData({ ...formData, [e.target.name]: e.target.value });
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: false
    }));
  };

  // const validateForm = () => {
  //   const { email, name, phone, password } = formData;

  //   if (!email || !name || !phone || !password) {
  //     toast.error("All fields are required!");
  //     return false;
  //   }

  //   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  //   if (!emailRegex.test(email)) {
  //     toast.error("Invalid email format!");
  //     return false;
  //   }

  //   if (name.length < 3) {
  //     toast.error("Username must be at least 3 characters!");
  //     return false;
  //   }

  //   const phoneRegex = /^[6-9]\d{9}$/;
  //   if (!phoneRegex.test(phone)) {
  //     toast.error("Invalid contact number! Must be 10 digits.");
  //     return false;
  //   }

  //   if (password.length < 6) {
  //     toast.error("Password must be at least 6 characters!");
  //     return false;
  //   }

  //   return true;
  // };
  const validateForm = () => {
    const { email, name, phone, password } = formData;
    let newErrors = {};

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[6-9]\d{9}$/;

    if (!email || !emailRegex.test(email)) newErrors.email = true;
    if (!name || name.length < 3) newErrors.name = true;
    if (!phone || !phoneRegex.test(phone)) newErrors.phone = true;
    if (!password || password.length < 6) newErrors.password = true;

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setLoading(true);
    try {
      const response = await signupUser(formData);
      toast.success("Signup Successful!");
      setFormData({ email: "", name: "", phone: "", password: "" });
      navigate("/login");
    } catch (error) {
      toast.error(error?.response?.data?.message || "Signup failed!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-div">
      <Navbar />
      {loading && <Loader />}



      <div className="New-login overflow-hidden md:pb-[54px] pb-[0px]">
        <div className="New-login-left">
          <div className="flex flex-col md:gap-[12px] gap-[8px] items-start">
            <div data-aos="fade-down" className="b1">
              <h2>Have Your Own</h2>
            </div>

            <div data-aos="fade-up" className="b2">
              <h2>Account With Us</h2>
            </div>
          </div>

          <div className="Register-div">
            <p data-aos="fade-up" className="text-[#4F5576] font-[400] text-[16px]">If you don’t have an account register</p>
            <p data-aos="fade-up" className="text-[#4F5576] font-[400] text-[16px]">
              You can{" "}
              <Link to="/login" style={{ color: "#075D9D", fontWeight: "600" }}>
                Login here
              </Link>{" "}
              !!
            </p>

            <div className="pt-[55px] md:flex justify-center items-center hidden">
              <img data-aos="flip-up" src="/assets/home/signup.svg" alt="signup" />
            </div>
          </div>
        </div>

        <div className="New-login-right lg:!mr-[90px] !mr-auto lg:ml-0 ml-auto  max-w-[539px] w-full">
          <div data-aos="fade-left" className="login-form">
            <div className="login-heading">
              <p className="poppins md:text-[21px] text-[16px] font-[400]">Welcome to <span className="text-[#6953A3] italic !font-[900]"> GISUL</span></p>
              <h6 className="md:pt-0 pt-[11px]">
                Have an Account ?<br />
                <Link to="/login" style={{ color: "#075D9D" }}>
                  Log in
                </Link>
              </h6>
            </div>
            <h3>Sign up</h3>
            <div className="grid md:grid-cols-2 grid-cols-1 md:gap-y-[35px] gap-y-[17px] md:gap-x-[19px] gap-x-[12px]">
              <div className="flex col-span-2 flex-col md:gap-[13px] gap-[8px]">
                <label className="label-default">Enter your email address</label>
                <input
                  type="email"
                  name="email"
                  className={`input-default ${errors.email ? 'border-red-500' : ''}`}
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter your email"
                />
              </div>
              <div className="flex flex-col md:col-span-1 col-span-2 md:gap-[13px] gap-[8px]">
                <label className="label-default">Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter your Name"
                  className={`input-default ${errors.name ? 'border-red-500' : ''}`}
                />
              </div>
              <div className="flex flex-col md:col-span-1 col-span-2 md:gap-[13px] gap-[8px]">
                <label className="label-default">Contact Number</label>
                <input
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Enter your contact number"
                  maxLength="10"
                  className={`input-default ${errors.phone ? 'border-red-500' : ''}`}
                />
              </div>
              <div className="flex col-span-2 flex-col md:gap-[13px] gap-[8px]">
                <label className="label-default">Enter your Password</label>
                <div className={`input-default relative ${errors.password ? 'border-red-500' : ''}`} style={{
                  width: "100%",
                  borderRadius: "5px",
                  outline: "none"
                }}>
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    className="w-full p-0 border-none outline-none focus:outline-none focus:ring-0 focus:border-none rounded"
                    placeholder="Enter your password"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-0 top-[50%] translate-y-[-50%] text-gray-500"
                    style={{ width: "100px", }}
                  >
                    {showPassword ? "🙈" : "👁️"}
                  </button>
                </div>
              </div>
            </div>
            <button className="btn-default md:mt-[63px] mt-[26px] md:mb-[36px] mb-[6px]"
              style={{ boxShadow: "0px 4px 19px 0px #7793414D" }} onClick={handleSubmit}>Sign up</button>
          </div>
          <div className="pt-[31px] md:hidden justify-center items-center flex">
              <img data-aos="flip-up" src="/assets/home/signup.svg" alt="sign-up" />
            </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SignUp;
